const Section = (props) => <div className="py-4 sm:py-16" {...props}/>

export default Section;